/**
 * @file InvoiceVariationNotesPanel.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-11-03
 * @modified 2026-11-03
 * @description The invoice window's "Variation review notes" (Cam, 3 Nov 2026
 *              — "We need to be able to make notes on invoices via the
 *              variation report modal … why is the variation okay (for
 *              example)?"): every note the Invoice Detail variation review
 *              recorded on this invoice — why its variation was approved or
 *              not (stage 1), or what was done and why (stage 2, Leave it
 *              included) — newest first, with who and when, from GET
 *              /api/invoices/:id `variationNotes`
 *              (invoiceVariationReviewService.notesForInvoice). Read only.
 *              Also says when a till invoice was edited here and no longer
 *              matches its till sale (`tillEditedHereText`).
 */

import React from 'react';
import './InvoiceCorrectionPanel.css';

const when = (v) => {
  if (!v) return '';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB');
};

function InvoiceVariationNotesPanel({ notes, tillEditedHereText = null }) {
  const list = Array.isArray(notes) ? notes : [];
  if (!list.length && !tillEditedHereText) return null;
  return (
    <div className="invoice-correction-panel invoice-variation-notes-panel" role="note" data-testid="invoice-variation-notes">
      {tillEditedHereText && (
        <div className="invoice-correction-head">
          <span className="material-symbols-rounded">point_of_sale</span>
          <span>{tillEditedHereText}</span>
        </div>
      )}
      {list.length > 0 && (
        <>
          <div className="invoice-correction-head">
            <span className="material-symbols-rounded">sticky_note_2</span>
            <strong>Variation review notes</strong>
          </div>
          {list.map(n => (
            <div key={n.id} className="invoice-correction-flag" data-note={n.id}>
              <p>{n.cleared ? <em>Note cleared</em> : n.note}</p>
              <p className="invoice-correction-meta">
                {n.what}
                {n.variation ? ` · ${n.variation}` : ''}
                {n.period ? ` · ${n.period}` : ''}
                {n.by ? ` · ${n.by}` : ''}
                {when(n.at) ? `, ${when(n.at)}` : ''}
              </p>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default InvoiceVariationNotesPanel;
